<template>
  <div class="comment-adsense-container" style="display:block; min-height: 100px; margin-top: 20px;">
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-format="autorelaxed"
         data-ad-client="ca-pub-5817088155848383"
         data-ad-slot="7581555937"></ins>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'CommentAdSense',
  setup() {
    onMounted(() => {
      // Load the AdSense script if it doesn't strictly exist
      const scriptSrc = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5817088155848383"
      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const adScript = document.createElement('script')
        adScript.async = true
        adScript.src = scriptSrc
        adScript.crossOrigin = "anonymous"
        document.head.appendChild(adScript)
      }

      // Initialize the ad
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {
        console.error('AdSense load error:', e)
      }
    })
  }
}
</script>

<style scoped>
.comment-adsense-container {
  width: 100%;
  overflow: hidden;
}
</style>
